import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';

import * as styles from './Header.module.scss';

export const Header: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer>
				<div className="row no-gutters">
					<div className="col-12 col-xl-6 mb-4">
						<h1
							className={classNames(
								styles.header,
								'font-size-large pb-2 mb-3 mt-0'
							)}
						>
							Time &#38; material
						</h1>
						<p className="font-size-sm line-height-26">
							This model assigns a project manager to the project, but the
							actual team is selected according to current demand. This also
							means that the team is variable in different phases of the
							project; for example, in the beginning, it is more of a Design
							&#38; Architecture team; later developers, DevOps, engineers, and
							testers join in. In this model, we only bill for actual project
							work, measured in a matter of time commitment at a fixed hourly
							rate.
						</p>
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
